<div class="breadcrumbs" *ngIf="isOnlyHomeActive || categories?.length">
  <ng-container *ngIf="isOnlyHomeActive; else isFullBreadcrumbs">
    <ng-container *ngTemplateOutlet="homePageRoute"></ng-container>
  </ng-container>

  <ng-template #isFullBreadcrumbs>
    <ng-container *ngIf="categories?.length">
      <span class="breadcrumbs__mobile">
        <ng-container *ngIf="categories[categories.length - 1] as category">
          <a (click)="navigateTo(category)"
             [routerLink]="[categoryRoute, category.slug]"
             class="breadcrumbs__link">
            {{ category?.name }}
          </a>
        </ng-container>
      </span>

      <span class="breadcrumbs__desktop">
        <ng-container *ngTemplateOutlet="homePageRoute"></ng-container>
        <ng-container *ngFor="let category of categories">
          <a (click)="navigateTo(category)"
             class="breadcrumbs__link"
             [routerLink]="[categoryRoute, category.slug]"
             test-target="breadcrumbs-link"
          >
            <span class="breadcrumbs__link__label">
              {{ category?.name }}
            </span>
          </a>
        </ng-container>
      </span>

    </ng-container>
  </ng-template>

  <ng-template #homePageRoute>
    <a class="breadcrumbs__link" homepageLink>
      <span class="breadcrumbs__link__label"> {{ 'CATALOG.DETAILS_PAGE.BREADCRUMBS.HOME.LABEL' | translate }}</span>
    </a>
  </ng-template>
</div>
